import {
  Box,
  Button,
  Heading,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  VStack,
} from '@chakra-ui/react';
import {IModalProps, Modal} from 'components/shared';
import {AddressItem} from 'components/shared/address-item';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {modalCloseButtonStyles} from 'theme';
import {TranslationKeys} from 'translations';
import {ICustomerAddress} from 'types';
import {SpacerUI} from 'ui/SpacerUI';

interface Props extends IModalProps {
  addresses?: ICustomerAddress[];
  selectedAddress: ICustomerAddress | undefined;
  onChangeAddress: (address: ICustomerAddress) => void;
  openAddAddressModal: any;
  t: (term: TranslationKeys) => string;
}

export const AddressModal: FC<Props> = ({
  isOpen,
  onClose,
  addresses,
  selectedAddress,
  onChangeAddress,
  openAddAddressModal,
  t,
}) => {
  const onChange = (value: ICustomerAddress) => {
    onChangeAddress(value);
    onClose();
  };
  const {route} = useRouter();
  const showSaveBtn = route === '/checkout';

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent maxW="700px" maxH={['85vh', '90vh']} mx={['15px', 0]}>
        <ModalHeader p="30px" display="flex" alignItems="center" justifyContent="space-between">
          <Heading fontSize="24px" fontWeight="bold">
            {t('SELECT_ADDRESS')}
          </Heading>
          <ModalCloseButton onClick={onClose} position="static" sx={modalCloseButtonStyles} />
        </ModalHeader>
        <ModalBody px="30px" pb="30px" pt="0" overflowY="scroll">
          <VStack spacing="20px" alignItems="stretch" mb="30px">
            {addresses?.map((address) => {
              if (!address?.address?.latitude || !address?.address?.longitude) return;
              return (
                <AddressItem
                  key={address.id}
                  address={address}
                  onSelect={onChange}
                  onEdit={openAddAddressModal}
                  isSelected={address.id === selectedAddress?.id}
                  withBorder
                  t={t}
                />
              );
            })}
          </VStack>
        </ModalBody>
        <ModalFooter p="0 30px 30px">
          <Box w="full">
            <Button variant={showSaveBtn ? 'outline' : 'primary'} ml="auto" w="full" onClick={openAddAddressModal}>
              + {t('ADD_NEW_ADDRESS')}
            </Button>
            {showSaveBtn && (
              <>
                <SpacerUI mode="vertical" size="md" />
                <Button variant="primary" ml="auto" w="full" onClick={onClose}>
                  {t('SAVE_ADDRESS')}
                </Button>
              </>
            )}
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
